export default __webpack_public_path__ + "static/tab1Img-e043d44c8bd9d3e7cce92dba62991b5e.png";